import { useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { generatePath, useHistory } from 'react-router-dom';

import { Insurance } from 'constants/routes';
import * as InsuranceActions from 'store/insurance/actions';
import * as InsuranceCalculationSelectors from 'store/insuranceCalculation/selectors';

const { ROUTES, ROUTE_NAMES } = Insurance;

export const useCreateNewPresenter = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const worksheetId = useSelector(InsuranceCalculationSelectors.selectWorksheetId);

  useEffect(() => {
    dispatch(InsuranceActions.createNew());
  }, []);

  useEffect(() => {
    if (!worksheetId) {
      return;
    }

    const pathname = generatePath(ROUTES[ROUTE_NAMES.VEHICLE_INFORMATION].path, {
      id: worksheetId,
    });

    history.push(pathname);
  }, [worksheetId]);
};
